import FTLIconButton from "./components/FTLIconButton";
export default FTLIconButton;
//# sourceMappingURL=index.js.map